import React, { Component } from 'react';

export default class DynamicOpenModalRuleForm extends Component {
  state = {
    fieldValue: this.props.paramRow.fieldValue,
    modal: this.props.paramRow.modal,
  };

  onChange = ({ target: { name, value, type, checked } }) => {
    const finalValue = type === 'checkbox' ? checked : value;

    this.setState({
      ...this.state,
      [name]: finalValue,
    });
    this.props.paramRow[name] = finalValue;
    this.props.createNewRow(this.props.paramRow);
  };

  onCustomSelectChange = (name, value) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
    this.props.paramRow[name] = value;
    this.props.createNewRow(this.props.paramRow);
  };

  render() {
    const { collectionFrom } = this.props;
    return (
      <tr>
        <td>
          {collectionFrom === 'sessionActionResponse' && (
            <input
              className="form-control form-control-sm"
              placeholder="Session Field Value"
              type="text"
              name="fieldValue"
              onChange={this.onChange}
              value={this.state.fieldValue}
            />
          )}
          {collectionFrom !== 'sessionActionResponse' && (
            <select
              name="fieldValue"
              onChange={this.onChange}
              className="form-control form-control-sm custom-select-sm"
              value={this.state.fieldValue}
            >
              <option value="">- Select One -</option>
              {this.props.collectionFieldValueOptions.map((e) => (
                <option key={e.value} value={e.value}>
                  {e.label}
                </option>
              ))}
            </select>
          )}
        </td>
        <td>
          <select
            name="modal"
            onChange={this.onChange}
            className="form-control form-control-sm custom-select-sm"
            value={this.state.modal}
          >
            <option value="">- Select One -</option>
            {this.props.modalOptions.map((e) => (
              <option key={e.value} value={e.value}>
                {e.label}
              </option>
            ))}
          </select>
        </td>
      </tr>
    );
  }
}
